<!-- 帮助文档 -->
<template>
  <div class="help-doc">
    <v-head :bg="'#181818'"></v-head>
    <div
      class="container"
      style="
      height: 100%;
      min-height: 100vh;
      display: flex;
      flex-direction: column;"
    >
      <!-- banner -->
      <div class="help-banner">
        <div class="help-banner-img" :style="'background-image:url(' + img + ')'">
          <div class="help-banner-zz"></div>
        </div>
        <div class="help-bannerMsg">
          <div class="bannerMsg-message-title">政策新闻库</div>
          <div class="bannerMsg-message-search">
            <el-input
              placeholder="请输入关键词搜索"
              v-model="searchModel"
              class="input-with-select"
              @keyup.enter.native="tipswords()"
            ></el-input>
            <i class="el-icon-search" @click="tipswords()"></i>
          </div>
        </div>
      </div>
      <!-- main -->
      <div class="help-main">
        <div class="help-main-bread">
          <span class="firstbread" @click="returnMod()">热点新闻摘要</span>
          <span class="secondbread" v-if="secondbread !== ''">
            <i class="el-icon-arrow-right"></i>
            {{ secondbread }}
          </span>
        </div>
        <div class="help-main-con">
          <!-- 常见问题详情 -->
          <div class="con-details">
            <h3 class="details-tit">{{ detailsList.title }}</h3>
            <div class="details-titsm">更新时间：{{ detailsList.date }}</div>
            <div class="details-con">
              <div class="details-itemss" v-for="(item,index) of detailsList.content" :key="index">
                <span class="itemss-title" v-if="item.type == 1">{{item.info}}</span>
                <p class="itemss-content" v-if="item.type == 2" v-html="returnText(item.info)"></p>
                <div class="itemss-img" v-if="item.type == 3">
                  <!-- <img :src="item.info" width="100%" alt /> -->
                  <el-image
                    class="itemss-img-main"
                    fit="cover"
                    :src="item.info"
                    :preview-src-list="toArray(item.info)"
                  ></el-image>
                </div>
                <!-- 分割线 -->
                <div class="itemss-line" v-if="item.type == 5"></div>
              </div>
              <div class="details-href" v-if="detailsList.urls">
                <span>参考链接：</span>
                <ul>
                  <li v-for="(items,index) of detailsList.urls.split(',')" :key="index">
                    <a href="javascript:void(0);" @click="toA(items)">{{ items }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import {
  Button,
  Input,
  Pagination,
  Image
} from 'element-ui'
export default {
  data () {
    return {
      img: 'https://sponsorentpic.nauac.com/20200506/96a3ad7bc60941eb82a31b5fcc049e75.jpg', // 临时图片
      searchModel: '',
      secondbread: '',
      detailsList: {
        title: '',
        date: '',
        content: '',
        urls: ''
      },
      // 常见问题列表数据（临时）
      problemList: [],
      // 分页参数
      pageSize: {
        page: 1,
        size: 20
      },
      pageTotal: 0
    }
  },
  watch: {
    searchModel (val) {
      if (val === '') {
        this.init()
      }
    }
  },
  components: {
    'v-head': vHead,
    'v-footer': vFooter,
    'el-button': Button,
    'el-input': Input,
    'el-pagination': Pagination,
    'el-image': Image
  },
  created () {
    this.init()
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  methods: {
    // 初始化加载列表
    init (type) {
      this.$http({
        method: 'post',
        url: '/document/info',
        params: {
          documentId: this.$route.query.id
        }
      }).then(res => {
        if (res.code === 100) {
          this.secondbread = res.result.title
          this.detailsList.title = res.result.title
          this.detailsList.date = res.result.updateDate
          this.detailsList.content = JSON.parse(res.result.content)
          this.detailsList.urls = res.result.urls
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    },
    // 文字回车/n转换
    returnText (val) {
      let str1 = val.replace(/\n/g, '<br/>')
      return str1
    },
    // 关键词点击事件
    tipswords () {
      this.$router.push({
        name: 'help',
        params: {
          searchModel: this.searchModel
        }
      })
    },
    // 返回常见问题列表事件
    returnMod () {
      this.$router.replace({
        path: '/help'
      })
    },
    toA (url) {
      window.open(url)
    },
    toArray (img) {
      let arr = []
      arr.push(img)
      return arr
    }
  }
}
</script>
<style src='./help_native.scss' lang="scss"></style>
<style lang="scss" scoped>
.help-doc {
  width: 100%;
  min-height: 100vh;
}
// banner
.help-banner {
  width: 100%;
  height: 450px;
  position: relative;
  .help-banner-img {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .help-banner-zz {
      background-color: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .help-bannerMsg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 0;
    box-sizing: border-box;
    .bannerMsg-message-title {
      font-size: 30px;
      color: #ffffff;
      padding: 25px 0;
    }
    .bannerMsg-message-search {
      position: relative;
      i {
        width: 40px;
        height: 100%;
        display: inline-block;
        font-size: 18px;
        color: #666666;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        cursor: pointer;
      }
    }
    .bannerMsg-message-tips {
      width: 620px;
      text-align: left;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      padding: 15px 0;
      .tips-words {
        margin: 0 5px;
        cursor: pointer;
      }
    }
  }
}
// main
.help-main {
  // width: 1200px;
  width: 100%;
  max-width: 1200px;
  margin: 50px auto;
  height: auto;
  flex: 1;
  .help-main-bread {
    font-size: 16px;
    color: #333333;
    text-align: left;
    font-weight: 700;
    padding: 25px 20px 35px 20px;
    box-sizing: border-box;
    line-height: 24px;
    span.firstbread {
      cursor: pointer;
    }
    span.firstbread:hover {
      color: #2178ec;
    }
  }
  .help-main-con {
    border: 1px solid #f5f2f2;
    // 常见问题展示样式
    .con-problem {
      padding: 15px 20px;
      box-sizing: border-box;
      .con-problemEach {
        padding: 20px 0 20px 0;
        border-bottom: 1px solid #f5f2f2;
        .problem-tit {
          font-size: 14px;
          font-weight: 700;
          text-align: left;
          padding: 10px 0 5px 0;
          box-sizing: border-box;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        .problem-tit:hover {
          color: #000000;
        }
        .problem-con {
          color: #666666;
          font-size: 12px;
          line-height: 22px;
          text-align: left;
          padding: 5px 0;
          // text-overflow: -o-ellipsis-lastline;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 2;
          // -webkit-box-orient: vertical;
        }
      }
      .con-problemEach:last-child {
        border-bottom: 0;
      }
    }
    // 常见问题详情展示样式
    .con-details {
      padding: 40px;
      box-sizing: border-box;
      .details-tit {
        font-size: 20px;
        // font-weight: 700;
        text-align: center;
        padding: 10px 0;
        box-sizing: border-box;
        color: #333333;
        line-height: 32px;
      }
      .details-titsm {
        font-size: 12px;
        color: #333333;
        text-align: center;
        padding: 30px 0;
        border-bottom: 1px dashed #dedede;
      }
      .details-con {
        padding-top: 25px;
        .details-itemss {
          margin-bottom: 15px;
          .itemss-title {
            white-space: normal;
            font-size: 16px;
            font-weight: 600;
            color: #202020;
            line-height: 26px;
            // i {
            //   height: 16px;
            //   width: 4px;
            //   display: inline-block;
            //   background-color: #4bd062;
            //   margin-right: 10px;
            //   margin-top: 5px;
            //   border-radius: 2px;
            //   vertical-align: top;
            // }
          }
          .itemss-content {
            font-size: 14px;
            line-height: 28px;
            color: #333333;
            text-align: justify;
          }
          .itemss-img {
            // width: 100%;
            width: auto;
            text-align: center;
            .itemss-img-main {
              img {
                font-size: 1px;
                max-width: 350px;
                max-height: inherit !important;
                width: inherit;
                height: auto;
              }
            }
          }
          .itemss-line {
            border-bottom: 1px solid #f2f2f2;
          }
        }
      }
    }
  }
  .con-pagination {
    margin-top: 25px;
    text-align: right;
  }
}
.details-href {
  display: flex;
  align-items: flex-start;
  margin-top: 60px;
  span {
    line-height: 20px;
    width: 90px;
    font-size: 14px;
  }
  ul {
    width: 100%;
    list-style: none;
    li {
      line-height: 20px;
      list-style: none;
      margin-bottom: 8px;
      a {
        font-size: 14px;
      }
    }
  }
}
</style>
<style lang="css">
.details-con p a {
  display: inline-block;
  text-decoration: none;
  color: #666666;
  line-height: 22px;
  text-align: left;
}
.details-con p a u,
.details-con p a u span {
  display: inline-block !important;
  text-decoration: none !important;
  color: #666666 !important;
}
.itemss-img .itemss-img-main > img {
  font-size: 1px;
  max-width: 350px;
  max-height: inherit !important;
  width: inherit;
  height: auto;
}
.con-details .itemss-img .el-image-viewer__wrapper img {
  font-size: 1px;
  max-width: 650px !important;
  max-height: inherit !important;
  width: inherit;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/help/helpDetails.vue